<template>
    <b-container fluid>
        <page-title>
            <h2>
                <router-link :to="{ name: 'InvoiceList' }" class="nav-link">Faktury sprzedażowe</router-link>
            </h2>
            <div class="page-title__buttons">
                <router-link :to="{ name: 'InvoiceCreate' }" class="btn btn-default"><span>Dodaj fakturę</span>
                    <svg-icon name="plus"/>
                </router-link>
            </div>
        </page-title>

        <div class="col page-element">
            <div v-if="deletedShowMessage != false" class="alert alert-success">Faktura "{{deletedShowMessage}} "została usunięta</div>
            <alert-loading v-if="loading"></alert-loading>
            <div v-if="error" class="alert alert-danger">{{ error }}</div>

            <div v-if="!loading">
                <div class="table-responsive">
                    <table class="table table-striped table-bordered table-hover table-clickable table-search">
                        <thead>
                        <tr>
                            <td><b-form-input type="text" class="form-control input-search" v-model="filter.fullNumber"/><svg-icon name="search"/></td>
                            <td><date-range-picker v-model="selectedCreateDatePeriod"></date-range-picker></td>
                            <td><b-form-input type="text" class="form-control input-search" v-model="filter.customer"/><svg-icon name="search"/></td>
                            <td></td>
                            <td></td>
                            <td><dropdown-search id="status-dropdown" :elements="currencyTypes" v-model="filter.currency" nameField="name" :showEmpty="true" valueField="id"/></td>
                            <td><dropdown-search id="status-dropdown" :elements="statusLists" v-model="filter.paid" :showEmpty="true" nameField="name" valueField="value" /></td>
                            <td class="no-wrap"><my-button variant="info" :action="getItems"/> <my-button icon="back" variant="primary" :action="resetFilter"/></td>
                        </tr>
                        <tr>
                            <th v-on:click="setOrder('fullNumber')" class="sorting" :class="getOrder('fullNumber')">Numer</th>
                            <th v-on:click="setOrder('createDate')" class="sorting" :class="getOrder('createDate')">Data wystawienia</th>
                            <th v-on:click="setOrder('customerData.name')" class="sorting" :class="getOrder('customerData.name')">Nabywca</th>
                            <th v-on:click="setOrder('amount')" class="sorting" :class="getOrder('amount')">Wartość netto</th>
                            <th v-on:click="setOrder('grossAmount')" class="sorting" :class="getOrder('grossAmount')">Wartość brutto</th>
                            <th v-on:click="setOrder('currency.name')" class="sorting" :class="getOrder('currency.name')">Waluta</th>
                            <th v-on:click="setOrder('paid')" class="sorting" :class="getOrder('paid')">Status</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in items">
                            <td>
                                <router-link :to="{name: 'InvoiceShow', params: { id: item.id, tab: 'invoice' }}">
                                    <span v-if="item.correction" class="icon--light"><svg-icon name="correction"/></span> {{ item['fullNumber'] }}
                                </router-link>
                            </td>
                            <td>
                                <router-link :to="{name: 'InvoiceShow', params: { id: item.id, tab: 'invoice' }}">
                                    {{ item['createDate'] | date }}
                                </router-link>
                            </td>
                            <td>
                                <router-link :to="{name: 'InvoiceShow', params: { id: item.id, tab: 'invoice' }}">
                                    {{ item['customerData']['name'] }}, NIP:&nbsp;{{ item['customerData']['nip'] }}
                                </router-link>
                            </td>
                            <td>
                                <router-link :to="{name: 'InvoiceShow', params: { id: item.id, tab: 'invoice' }}">
                                    {{ item['amount'] }}
                                </router-link>
                            </td>
                            <td>
                                <router-link :to="{name: 'InvoiceShow', params: { id: item.id, tab: 'invoice' }}">
                                    {{ item['grossAmount'] }}
                                </router-link>
                            </td>
                            <td>
                                <router-link :to="{name: 'InvoiceShow', params: { id: item.id, tab: 'invoice' }}">
                                    {{ item['currency']['name'] }}
                                </router-link>
                            </td>
                            <td>
                                <router-link :to="{name: 'InvoiceShow', params: { id: item.id, tab: 'invoice' }}">
                                    <span v-if="item['paid']" class="element_status closed">Zapłacona</span>
                                    <span v-if="!item['paid'] && !item['deducted']" class="element_status open">Niezapłacona</span>
                                </router-link>
                            </td>
                            <td>
                                <router-link :to="{name: 'InvoiceUpdate', params: { id: item['id'] }}" v-b-tooltip.hover.bottom title="Edytuj" class="btn btn-icon">
                                    <svg-icon name="edit"/>
                                </router-link>
                                <a v-if="item.paid == false"
                                   href="#" class="btn btn-icon" @click.prevent="markAsPaid(item)" v-b-tooltip.hover.bottom title="Oznacz jako opłaconą">
                                    <svg-icon name="money"/>
                                </a>
                                <a href="#" class="btn btn-icon" @click.prevent="downloadFile(item.activeDocumentID)" v-b-tooltip.hover.bottom title="Pobierz">
                                    <svg-icon name="download"/>
                                </a>
                                <a href="#" class="btn btn-icon" @click.prevent="previewFile(item.activeDocumentID)" v-b-tooltip.hover.bottom title="Podgląd">
                                    <svg-icon name="preview"/>
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <pagination :changePage="changePage" :currentPage="currentPage" :pagination="pagination"></pagination>
            </div>
        </div>
    </b-container>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import sort from '../../utils/order'
    import http from '../../utils/http'
    import moment from 'moment'

    export default {
    data: function () {
      return {
        deletedShowMessage: false,
        selectedCreateDatePeriod: null,
        selectedStatus: null,
        statusLists:[
            {value:'true', name: 'Zapłacona'},
            {value:'false', name: 'Niezapłacona'},
        ]
      }
    },
    computed: {
      ...mapGetters({
        deletedItem: 'invoice/del/deleted',
        error: 'invoice/list/error',
        items: 'invoice/list/items',
        loading: 'invoice/list/loading',
        currentPage: 'invoice/list/currentPage',
        pagination: 'invoice/list/pagination',
        order: 'invoice/list/order',
        filter: 'invoice/list/filter',
        currencyTypes: 'config/config/currencyTypes',
        paymentStatus: 'invoice/list/paymentStatus'
      })
    },
    methods: {
      resetFilter(){
        for (var key in this.filter ){
          this.filter[key] = undefined;
        }
        this.selectedCreateDatePeriod = null;
        this.getItems();
      },
        markAsPaid (item) {
            if (window.confirm('Czy na pewno chcesz oznaczyc fakturę nr ' + item.fullNumber + ' jako opłaconą?'))
                this.$store.dispatch('invoice/list/markAsPaid', item);
        },
      downloadFile (documentId) {
        http.download('/download/invoice/document/' + documentId + '?')
      },
      previewFile (documentId) {
        http.preview('/download/preview/invoice/document/' + documentId + '?')
      },
      getOrder: function (column) {
        return sort(this.order, column)
      },
      ...mapActions({
        getItems: 'invoice/list/getItems',
        setOrder: 'invoice/list/order',
        changePage: 'invoice/list/changePage'
      })
    },
    created () {
      if(this.filter.createDate){
        this.selectedCreateDatePeriod = [
          new Date( this.filter.createDate.after),
          new Date( this.filter.createDate.before)
        ]
      }
      if (this.deletedItem != null) {
        this.deletedShowMessage = this.deletedItem.fullNumber
        setTimeout(() => {
          this.deletedShowMessage = false
          this.$store.dispatch('invoice/del/reset')
        }, 5000)
      }
      this.$store.dispatch('invoice/list/getItems')

    },
    watch: {
      selectedCreateDatePeriod: function (date) {
        if(date){
          this.filter.createDate = {
            before: moment(date[1]).format('YYYY-MM-DD 23:59:59'),
            after: moment(date[0]).format('YYYY-MM-DD 00:00:00'),
          }
        }else{
          this.filter.createDate = undefined
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// List.vue?01cd13a7